const TRACKING_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "gclid",
];

const storeTrackingParams = () => {
  const params = new URLSearchParams(window.location.search);

  TRACKING_KEYS.forEach((key) => {
    const value = params.get(key);

    // Only overwrite if a value exists in the URL.
    if (value) {
      sessionStorage.setItem(key, value);
    }
  });

  // Save the first landing page only.
  if (!sessionStorage.getItem("landing_page")) {
    sessionStorage.setItem("landing_page", window.location.href);
  }

  // Save the first referrer only.
  if (!sessionStorage.getItem("referrer")) {
    sessionStorage.setItem("referrer", document.referrer || "");
  }
};

export default storeTrackingParams;